export default __webpack_public_path__ + "static/media/pic.1cd93eef.svg";